import { StyleSheet } from 'react-native';

import Text from './Text';

interface ListEmptyComponentProps {
  label: string;
}

const ListEmptyComponent = ({ label }: ListEmptyComponentProps) => {
  return <Text style={styles.listEmpty}>{label}</Text>;
};

const styles = StyleSheet.create({
  listEmpty: {
    textAlign: 'center'
  }
});

export default ListEmptyComponent;
